import React, { useCallback, useEffect, useState } from "react";

const ZipInput = ({
    value = "",
    onChange,
    onValidCep,
    setError,
    setErrorOK,
    placeholder = "Digite o CEP",
    disabled = false,
    className
}) => {
    const formatCep = (value) => {
        const digitsOnly = value.replace(/\D/g, "").slice(0, 8);

        if (digitsOnly.length <= 5) {
            return digitsOnly;
        }

        return `${digitsOnly.slice(0, 5)}-${digitsOnly.slice(5)}`;
    };

    const [internalValue, setInternalValue] = useState(formatCep(value));

    useEffect(() => {
        setInternalValue(formatCep(value));
    }, [value]);

    const clearCep = (value) =>
        value.replace(/\D/g, "");

    const handleChange = useCallback(
        (e) => {
            const formatted = formatCep(e.target.value);
            const cleanCep = clearCep(formatted);

            setInternalValue(formatted);
            onChange(cleanCep);

            if (!cleanCep.length) {
                setErrorOK("notOk");
                setError("Preenchimento obrigatório");
            } else if (cleanCep.length < 8) {
                setErrorOK("notOk");
                setError("Preenchimento incompleto");
            } else {
                setError("")
                setErrorOK("ok")
                onValidCep(cleanCep);
            }
        },
        [onChange, onValidCep]
    );

    return (
        <input
            className={className}
            type="text"
            value={internalValue}
            onChange={handleChange}
            placeholder={placeholder}
            maxLength={9}
            inputMode="numeric"
            disabled={disabled}
        />
    );
};

export { ZipInput };